import DataManager from 'utils/DataManager/dataManager';
import { DataState } from 'typings/enums';
import { IJobDataManager } from 'typings/dataManagers';

class JobDataManager extends DataManager implements IJobDataManager {
    async getJobs(
        masterAccountId: string,
        managerSourceId: string,
        employeeJobCodeKey: string): Promise<Nullable<IJobSummary[]>> {
        const receive = () => this._getDataRequest<IJobSummary[]>(
            // tslint:disable-next-line:max-line-length
            `/api/accounts/${masterAccountId}/team/managers/jobs/?managerSourceId=${encodeURIComponent(managerSourceId)}&jobCodeKey=${encodeURIComponent(employeeJobCodeKey)}`);
        return await this.getData<IJobSummary[]>(receive, false);
    }

    async getJobsUnderManager(masterAccountId: string, jobCodeKey?: string): Promise<Nullable<IJobSummary[]>> {
        const jobCodeKeyParam = jobCodeKey ? `?jobCodeKey=${encodeURIComponent(jobCodeKey)}` : '';
        const receive = () => this._getDataRequest<IJobSummary[]>(
            `/api/accounts/${masterAccountId}/team/jobList/${jobCodeKeyParam}`);
        return await this.getData<IJobSummary[]>(receive, false);
    }

    async getJobDetails(masterAccountId: string, jobId: string | number): Promise<Nullable<JobDetails>> {
        const receive = () => this._getDataRequest<JobDetails>(
            `/api/accounts/${masterAccountId}/team/jobs/${encodeURIComponent(jobId)}`);
        return await this.getData<JobDetails>(receive, false);
    }

    async getJobLocations(masterAccountId: string, jobCode: string): Promise<Nullable<JobLocation[]>> {
        const receive = () => this._getDataRequest<JobLocation[]>(
            `/api/accounts/${masterAccountId}/team/jobLocations/${encodeURIComponent(jobCode)}`);
        return await this.getData<JobLocation[]>(receive, false);
    }

    setDataState(state: DataState): void {
        this.protectedTransitionDataState(state);
    }
}

export { JobDataManager };
export default JobDataManager;